export function getFormValuesAndRules(form) {
  const formValues = {};
  const formRules = {};

  Object.entries(form).forEach(([key, field]) => {
    formValues[key] = field.value; 
    if (field.rules) {
      formRules[key] = field.rules;
    }
  });

  return { formValues, formRules };
}

export function getValidNonNegativeIntegerInput(input) {
  // Remove non-digit characters
  let cleanedInput = input.replace(/[^\d]/g, '');

  // Disallow multiple leading zeros
  cleanedInput = cleanedInput.replace(/^0+(?=\d)/, ''); // Remove leading zeros except for a single zero
  return cleanedInput;
}

export function getValidPositiveIntegerInput(input) {
  // Remove non-digit characters
  let cleanedInput = input.replace(/[^\d]/g, '');
  // Remove all leading zeros
  cleanedInput = cleanedInput.replace(/^0+/, ''); 
  return cleanedInput;
}

export function getValidPositiveFloatInput(input) {
  // Remove any non-digit and non-dot (.) characters
  let cleanedInput = input.replace(/[^\d.]/g, '');
  // Only allow a single dot (.)
  const dotIndex = cleanedInput.indexOf('.'); // Find the first occurrence of "."
  if (dotIndex !== -1) {
    // If there's more than one ".", remove any subsequent dots
    cleanedInput = cleanedInput.substring(0, dotIndex + 1) + cleanedInput.substring(dotIndex + 1).replace(/\./g, '');
  }
  // Remove leading zeros but keep "0." for decimal numbers
  cleanedInput = cleanedInput.replace(/^0+(?=\d)/, '');
  return cleanedInput;
}

export function getValidIntegerInput(input) {
  // Remove non-digit and non-hyphen characters
  let cleanedInput = input.replace(/[^-\d]/g, '');

  // Disallow multiple '-' and '-' not at the beginning
  if (cleanedInput.indexOf('-') > 0 || cleanedInput.split('-').length > 2) {
    cleanedInput = cleanedInput.replace(/-/g, ''); // Remove all '-' except the first one
  }

  // Disallow multiple leading zeros
  cleanedInput = cleanedInput.replace(/^0+(?=\d)/, ''); // Remove leading zeros except for a single zero
  
  return cleanedInput;
}

export async function  assignReturnAndRefundInitSetting(values, settings) {
  values.returnOrRefund = settings.accept_return_refund;
  values.returnDays = String(settings.accepted_return_refund_days);
  
  const type = settings.merchandise_refund_deduction_type

  values.refundType = type === "no_deduction" ? "full"
                                : type === "by_percentage" 
                                  ? "percentage"
                                  : "amount";

  const deduct = settings.merchandise_refund_deduction_value;
  values.deduct = type === "no_deduction" ? null
                    : type === "by_percentage" 
                      ? (deduct * 100).toFixed(0)
                      : deduct.toFixed(2);
  values.explanation = settings.merchandise_refund_deduction_reason;


}

export function getMerchandiseOptions(merchList) {
  let result = [];
  // get Discount Panel
  let options = (
    merchList
  ).map((merch) => {
    return { id: merch.id, name: merch.name, isMerch: true };
  });
  result.push({
    label: "MERCHANDISE",
    options,
  });
  return result;
}
